import React, { useState } from "react";
import PropTypes from "prop-types";
import { markdown } from "markdown";
import Menu from "antd/lib/menu";
import HtmlContent from "@redash/viz/lib/components/HtmlContent";
import TextboxDialog from "@/components/dashboards/TextboxDialog";
import Widget from "./Widget";
import { useTheme } from "@/components/ThemeProvider";

function TextboxWidget(props) {
  const { widget, canEdit } = props;
  const [text, setText] = useState(widget.text);
  const { isDarkMode } = useTheme();

  const editTextBox = () => {
    TextboxDialog.showModal({
      text: widget.text,
    }).onClose(newText => {
      if (newText !== undefined) {
        widget.text = newText;
        setText(newText);
        return widget.save();
      }
    });
  };

  const TextboxMenuOptions = [
    <Menu.Item key="edit" onClick={editTextBox}>
      Edit
    </Menu.Item>,
  ];

  if (!widget.width) {
    return null;
  }

  return (
    <Widget {...props} menuOptions={canEdit ? TextboxMenuOptions : null} className={`widget-text ${isDarkMode ? 'dark-mode' : ''}`}>
      <HtmlContent className={`body-row-auto scrollbox t-body p-15 markdown ${isDarkMode ? 'dark-mode' : ''}`}>
        {markdown.toHTML(text || "")}
      </HtmlContent>
    </Widget>
  );
}

TextboxWidget.propTypes = {
  widget: PropTypes.object.isRequired,
  canEdit: PropTypes.bool,
};

TextboxWidget.defaultProps = {
  canEdit: false,
};

export default TextboxWidget;
